import React, { useState } from "react";
import "../styles/Carhelppanel.css";
import { useGame } from "../GameContext";
interface Helppanels {
  GameStyle: 'animal' | 'family';
}
const Helppanel: React.FC<Helppanels> = ({GameStyle}) => {
  const { isHelpPanelOpen, setHelpPanelOpen } = useGame();
  const [showhelpPivots, setShowhelpPivots] = useState<string>("pivotTask");

  if (!isHelpPanelOpen) {
    return null;
  }

  return (
    <div className="car-helpPanel" id="car-helpPanel">
      <img
        src="../img/close.svg"
        id="car-closeButton"
        alt="Закрыть"
        className="car-closeButton"
        onClick={() => setHelpPanelOpen(false)}
      />
      <div className="car-helpPivots">
        <div
          className="car-selectPivots"
          id={showhelpPivots === "pivotTask" ? "car-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotTask")}
        >
          Задача
        </div>
        <div
          className="car-selectPivots"
          id={showhelpPivots === "pivotModes" ? "car-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotModes")}
        >
          Режимы
        </div>
        <div
          className="car-selectPivots"
          id={showhelpPivots === "pivotButtons" ? "car-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotButtons")}
        >
          Кнопки
        </div>
        <div
          className="car-selectPivots"
          id={showhelpPivots === "pivotCommands" ? "car-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotCommands")}
        >
          Команды
        </div>
      </div>
      {showhelpPivots === "pivotTask" && (
        <div id="car-commandsCards">
          <div className="car-helpCard">
            <div className="car-cardCaption">Суть игры</div>
            <div>
              <div>
                {GameStyle === "animal"
                  ? "Кузьме нужно переправить пассажиров - волка, козу и капусту с одного берега на другой."
                  : "Переправить семью с одного берега на другой."}
              </div>
            </div>
          </div>
          <div className="car-helpCard">
            <div className="car-cardCaption">Правила игры</div>
            <div>
              <div>
                {" "}
                {GameStyle === "animal" ? (
                  <>
                    <b>1.</b> На катере может быть только 1 пассажир.
                    <br />
                    <b>2.</b> Волка и козу оставлять вместе нельзя, волк съест
                    козу.
                    <br />
                    <b>3.</b> Козу и капусту оставлять вместе нельзя, коза съест
                    капусту.
                  </>
                ) : (
                  <>
                    Скутер может выдержать на воде только двух детей или одного
                    взрослого.<br/>
                    <br/>
                    *Постарайся решить задачу за наименьшее количество команд.
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {showhelpPivots === "pivotModes" && (
        <div id="car-modesCards">
          <div className="car-helpCard">
            <div className="car-cardCaption">
              <img
                src="../img/button/control_2.svg"
                className="car-iconhelp"
                alt="знакомство"
              />{" "}
              Знакомство
            </div>{" "}
            <div>
              {" "}
              Ты можешь изучить команды Котобота. Нажимай на кнопки над полем
              кода. И твои действия сразу отобразятся на поле Котобота, без
              написания программы. В этом режиме нельзя ввести код программы,
              поле ввода заблокировано.
            </div>
          </div>
          <div className="car-helpCard">
            <div className="car-cardCaption">
              <img
                src="../img/button/edit_2.svg"
                className="car-iconhelp"
                alt="программирование"
              />{" "}
              Программирование
            </div>{" "}
            <div>
              {" "}
              Код программы надо писать в поле ввода кода. Для этого используй
              команды Котобота. Команды можно писать самому, а можно ускорить
              процесс с помощью кнопок над полем кода. Они вводят кодовые слова
              целиком.
            </div>
          </div>
          <div className="car-helpCard">
            <div className="car-cardCaption">
              <img
                src="../img/button/run_2.svg"
                className="car-iconhelp"
                alt="запуск"
              />{" "}
              Запуск
            </div>{" "}
            <div>
              {" "}
              Хочешь увидеть, что делает твоя программа? Запускай, и Котобот
              выполнит её! Если программа уже дописана и она решает задачу,
              Котобот поздравит тебя. Если в программе есть ошибка, ты увидишь
              сообщение о ней. А если программа не дописана, ты увидишь, что уже
              сделано и что ещё осталось дописать.
            </div>
            <br/>
            <div className="car-cardCaption">
              {" "}
              <img
                src="../img/button/stop2.svg"
                className="car-iconhelp"
                alt="стоп"
              />{" "}
              Стоп
            </div>
            <div>
              {" "}
              Останавливает работу программы и переводит в режим программировани.
            </div>
          </div>
          <div className="car-helpCard">
            <div className="car-cardCaption">
              <img
                src="../img/button/debug_2.svg"
                className="car-iconhelp"
                alt="отладка"
              />{" "}
              Отладка
            </div>{" "}
            <div>
              {" "}
              Нужно понять, как работает твой алгоритм? Активируйте отладку! Он
              позволяет исполнить программу пошагово, наблюдая за действиями в
              реальном времени. Ты сможете локализовать ошибку, проверить логику
              условий и циклов, и увидеть точный путь выполнения вашего кода.
              {" "}
            </div>
            <br/>
            <div className="car-cardCaption">
              <img
                src="../img/button/next.svg"
                className="car-iconhelp next-help"
                alt="далее"
              />{" "}
              Далее
            </div>
            <div>
              {" "}
              Выполняет следующую команду программы.
            </div>
          </div>
        </div>
      )}
      {showhelpPivots === "pivotButtons" && (
        <div id="car-buttonsCardsEdit">
          <div className="car-helpCard">
            <div className="car-cardCaption">
              <div className="carrier-transButtons-help">
                <img
                  src="/img/button/AB.svg"
                  className="carrier-icon-help"
                  alt="AtoB"
                />
                <img
                  src="/img/button/BA.svg"
                  className="carrier-icon-help"
                  alt="BtoA"
                />
              </div>
            </div>
            {GameStyle==="animal"? <div>Добавляют команды перемещения катера с берега на берег.</div>
          :<div>Добавляют команды перемещения скутера с берега на берег.</div>}            
</div>
          <div className="car-helpCard">
            <div className="car-cardCaption">
              {GameStyle === "animal" ? (
                <div className="carrier-persButtons-help-animal">
                  <img
                    src="/img/carrier/buttonCharacters/animal/wolf.svg"
                    className="carrier-icons-help"
                    alt="wolf"
                  />
                  <img
                    src="/img/carrier/buttonCharacters/animal/goat.svg"
                    className="carrier-icons-help"
                    alt="goat"
                  />
                  <img
                    src="/img/carrier/buttonCharacters/animal/cabbage.svg"
                    className="carrier-icons-help"
                    alt="cabbage"
                  />
                </div>
              ) : (
                <div className="carrier-persButtons-help-family">
                  <img
                    src="/img/carrier/buttonCharacters/family/mom.svg"
                    className="carrier-icons-help"
                    alt="wolf"
                  />
                  <img
                    src="/img/carrier/buttonCharacters/family/dad.svg"
                    className="carrier-icons-help"
                    alt="goat"
                  />
                  <img
                    src="/img/carrier/buttonCharacters/family/children2.svg"
                    className="carrier-icons-help"
                    alt="cabbage"
                  />
                  <img
                    src="/img/carrier/buttonCharacters/family/children1.svg"
                    className="carrier-icons-help"
                    alt="cabbage"
                  />
                </div>
              )}
            </div>
            {GameStyle==="animal"? <div>Добавляют пассажира.</div>: <div>Добавляют водителя.</div>}
           
          </div>
        </div>
      )}
      {showhelpPivots === "pivotCommands" && (
        <div id="car-commandsCards">
          <div className="car-helpCard">
            <div className="car-cardCaption">Перемещения</div>
            <div>
              <div className="car-code">
                {GameStyle === "animal" ? (
                  <>
                    {" "}
                    <b>move (x , y , passenger)</b> <br />
                    <b>x</b> - берег, с которого отправляется катер
                    <br />
                    <b>y</b> - берег, на который прибывает катер <br />
                    <b>passenger</b> - пассажир, которого нужно взять на катер{" "}
                  </>
                ) : (
                  <>
                    <b>move (x , y , driver)</b> <br />
                    <b>move (x , y , driver1, driver2)</b> <br />
                    <b>x</b> - берег, с которого отправляется скутер
                    <br />
                    <b>y</b> - берег, на который прибывает скутер <br />
                    <b>driver</b> - водитель скутера{" "}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Helppanel;
